import React, { useEffect, useRef, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import BuyingSheetModal from "../../modal/BuyingSheetModal";
import EmailModal from "../../modal/EmailModal";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { convertDataToBuyingSheet, convertDataToWarehouseSheet } from "../helpers/print";
import { dateFormat } from "../helpers/date";
import ConfirmModal from "../../modal/ConfirmModal";
import { GETREQUEST, POSTREQUEST } from "../helpers/ServiceRequest";
import Toastify from "../common/Toastify";
import { generateWarehousePdf } from "../Pdfs/warehouseSheet";
import { generateBuyingPdf } from "../Pdfs/buyingSheet";
import { generatePurchasePdf } from "../Pdfs/purchaseSheet";

function PrintOrders() {
  const [showModal, setShowModal] = useState(false);
  const [buyingSheetData, setBuyingSheetData] = useState([])
  const [warehouseSheetData, setWarehouseSheetData] = useState([])
  const [fromDate, setFromDate] = useState(dateFormat());
  const [allAgentData, setAllAgentData] = useState([]);
  const [agentId, setAgentId] = useState("All Agents");
  const [agentCode, setAgentCode] = useState("");
  const [agents, setAgents] = useState([]);
  const [allCustomerData, setAllCustomerData] = useState([]);
  const [customerId, setCustomerId] = useState("all");
  const [customers, setCustomers] = useState([]);
  const [isBuyingSheet, setIsBuyingSheet] = useState(true);
  const [isBuyingPrice, setIsBuyingPrice] = useState(true);
  const [isWarehouseSheet, setIsWarehouseSheet] = useState(true);
  const [isPurchaseOrder, setIsPurchaseOrder] = useState(true);
  const [agentDNDEmail, setAgentDNDEmail] = useState(false);
  const [crates, setCrates] = useState([]);
  const [type, setType] = useState('');
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [agentsData, setAgentsData] = useState([]);
  const [userName, setUserName] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const { user } = useAuth();

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });

  useEffect(() => {
    const fetchData = async () => {

      
      let containersURL = process.env.REACT_APP_API_URL + "/get-all-containers";

      let containersResponse = await GETREQUEST(containersURL, user.jwtToken);

      if (containersResponse?.data) {
        let crList = [];
        containersResponse.data.forEach((item) => {
          crList = [...crList, { label: item.TypeInCode, value: item.ContainerID, ...item }];
        });
        setCrates(crList)
      }
    }

    fetchData();

  }, [])

  useEffect(() => {
    fetchBuyingData();
    fetchWarehouseData();
  }, [fromDate]);

  useEffect(() => {
    const fetchData = async () => {
      let filterAgentData = [...allAgentData]
      if (agentId != "All Agents") {
        filterAgentData = allAgentData.filter((agentData) => agentData.AgentID == agentId)
      }
      let updatedBuyingData = await convertDataToBuyingSheet(filterAgentData)
      setBuyingSheetData(updatedBuyingData)

      if (agentId != "All Agents") {
        let DNDEmail = updatedBuyingData.DNDEmail ? true : false;
        setAgentDNDEmail(DNDEmail)
      } else {
        setAgentDNDEmail(false)
      }

      let agentsData = [];
      updatedBuyingData?.map((data) => {
        // if (data?.DNDEmail != null && data?.DNDEmail)
          agentsData.push({ email: data.emailAddress, id: data.agentId });
      })

      setAgentsData(agentsData);
    }
    fetchData()
  }, [agentId]);

  useEffect(() => {
    let filterCustomerData = [...allCustomerData]
    if (customerId != "All") {
      filterCustomerData = allCustomerData.filter((agentData) => agentData.tblOrder?.CustomerID == customerId)
    }
    convertDataToWarehouseSheet(filterCustomerData, customerId);
  }, [customerId]);

  const fetchBuyingData = async () => {
    let buyingSheetURL = process.env.REACT_APP_API_URL + `/print-buying-sheet`;
    let payload = {
      "agentId": "All Agents",
      "fromDate": fromDate,
      "vpCodes": "all"
    }
    let response = await POSTREQUEST(buyingSheetURL, payload, user.jwtToken);

    if (response?.data) {
      setAllAgentData(response.data)
      setAgentDNDEmail(false)
      let updatedBuyingData = await convertDataToBuyingSheet(response.data);
      setBuyingSheetData(updatedBuyingData)
      // setting Email DND flag for that single agent
      if (agentId != "All Agents") {
        let DNDEmail = response.data[0]?.tblAgent?.DNDEmail ? true : false;
        setAgentDNDEmail(DNDEmail)
      } else {
        setAgentDNDEmail(false)
      }

      let filterAgent = [];
      let agentsData = [];
      updatedBuyingData?.map((data) => {
        filterAgent.push({
          AgentCode: data.agentCode, AgentID: data.agentId
        });
        // if (data?.DNDEmail != null && data?.DNDEmail)
          agentsData.push({ email: data.emailAddress, id: data.agentId });
      })

      filterAgent?.sort((a, b) => a.AgentCode.localeCompare(b.AgentCode));
      setAgents(filterAgent);
      setAgentsData(agentsData);
    }
  }

  const fetchWarehouseData = async () => {
    let warehouseSheetURL = process.env.REACT_APP_API_URL + `/print-warehouse-sheet`;
    let payload = {
      "customerId": "all",
      "fromDate": fromDate,
      "vpCodes": "all"
    }
    let res = await POSTREQUEST(warehouseSheetURL, payload, user.jwtToken);
    if (res?.data) {
      let totalCustomersProducts = 0;
      let updatedData = res.data && res.data.length > 0 && res.data.map((item) => {
        return {
          ...item,
          ContainerName: crates.length > 0 && crates.find(crate => crate.ContainerID == item.ContainerID)?.TypeInCode || '',
        }
      })
      setAllCustomerData(updatedData);
      const warehouseSheetData = convertDataToWarehouseSheet(updatedData, customerId);
      // counting products for all customers

      const newWarehouseData = warehouseSheetData.map((data) => {
        const newObj = { ...data, TotalProducts: data.products.length - data.addBlankRows }
        totalCustomersProducts += data.products.length;
        return newObj;
      });

      let newCustomers = [];
      newWarehouseData?.map((data) => {
        newCustomers.push({ value: data.CustomerID, CustomerCode: data.CustomerCode })
      })
      newCustomers.sort((a, b) => a.CustomerCode.localeCompare(b.CustomerCode));
      setCustomers(newCustomers);
      setWarehouseSheetData(newWarehouseData);
    }
  }

  const handlePrintSheets = async (preview) => {
    try {
      if (isBuyingSheet) {
        await generateBuyingPdf(buyingSheetData, false, isBuyingPrice);
      }
      if (isWarehouseSheet) {
        await generateWarehousePdf(warehouseSheetData, preview);
      }
      if (isPurchaseOrder) {
        await generatePurchasePdf(buyingSheetData);
      }
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  }

  const handleSendEmail = async (to, subject, body) => {
    setMessageType('')
    setMessage('')
    let emailURL = `${process.env.REACT_APP_API_URL}/email-pdf`;
    const payload = {
      to,
      subject,
      emailBody: body,
      id: agentId,
      type,
      date: fromDate
    }
    let response = await POSTREQUEST(emailURL, payload, user.jwtToken);
    if (response?.data) {
      if (response?.data.success) {
        setMessage(response?.data.message);
        setMessageType('success');
      } else {
        setMessage(response?.data.message);
        setMessageType('error');
      }
    }
    else {
      setMessage(response?.data?.message || response?.data?.error?.message || 'Failed to send Email !!');
      setMessageType('error');
    }
  }

  const handleSendBulkEmail = async () => {
    setMessageType('')
    setMessage('')
    let emailURL = `${process.env.REACT_APP_API_URL}/bulk-email-pdf`;
    const payload = {
      id: agentId,
      type,
      date: fromDate,
      to: agentsData,
    }
    let response = await POSTREQUEST(emailURL, payload, user.jwtToken);
    if (response?.data) {
      if (response?.data.success) {
        setMessage(response.data.message);
        setMessageType('success');
      } else {
        setMessage(response.data.message);
        setMessageType('error');
      }
    }
    else {
      setMessage(response?.error?.message || 'Failed to send Email !!');
      setMessageType('error');
    }
  }

  const isAllSheetSelected = (isPurchase, isBuying, isWareHouse) => {
    if (isPurchase && isBuying == false && isWareHouse == false) {
      setType('purchase');
    }
    else if (isPurchase == false && isBuying && isWareHouse == false) {
      setType('buying');
    }
    else if (isPurchase == false && isBuying == false && isWareHouse) {
      setType('');
    } else {
      setType('');
    }
  }

  const handleEmailDisabled = () => {
    if (!type && agentsData.length > 0) {
      return true
    }
    else if (agentDNDEmail) {
      return true;
    }
    else if(agentsData.length === 0) {
      return true
    }
  }
  return (
    <React.Fragment>
      {message && <Toastify message={message} type={messageType} />}
      {showModal && (
        <BuyingSheetModal modal={showModal} setModal={setShowModal} />
      )}
      {showEmailModal && (
        agentsData.length > 1 ?
          <ConfirmModal modal={showEmailModal} modalHeader="Compose Email To All Agents" modalBody="You are about to send Email to all agents. Are you sure ?" setModal={setShowEmailModal} onConfirm={handleSendBulkEmail} /> :
          <EmailModal modal={showEmailModal} setModal={setShowEmailModal} code={type} handleSendEmail={handleSendEmail} emailUser={agentsData[0]?.email} userName={userName} date={fromDate} />

      )}
      <Header />
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/all-orders"
                    className="text-decoration-none text-primary"
                  >
                    Orders
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Print Order
                </li>
              </ol>
            </nav>
          </div>
          <div className="row justify-content-center">
            <div className="width-xl-35 width-lg-60 width-md-80">
              <div className="card">
                <div className="card-header p-0 bg-white">
                  <h1 className="title-semibold p-4 fs-20 mb-0">
                    Print Orders
                  </h1>
                </div>
                <div className="card-body p-4">
                  <div className="row gx-3">
                    <div className="col-sm-6">
                      <ul className="list-group">
                        <li className="list-group-item d-flex justify-content-between align-items-center bg-greylite cpy-11">
                          <div className="form-check mb-0 d-flex align-items-center">
                            <input
                              className="form-check-input me-1"
                              type="checkbox"
                              id="firstCheckboxStretched2"
                              checked={isPurchaseOrder}
                              onChange={(e) => {
                                setIsPurchaseOrder(!isPurchaseOrder)
                                isAllSheetSelected(!isPurchaseOrder, isBuyingSheet, isWarehouseSheet)
                              }}
                            />

                            <label
                              className="form-check-label cms-6"
                              htmlFor="firstCheckboxStretched2"
                            >

                              Purchase Order
                            </label>
                          </div>

                        </li>
                        <li className="list-group-item  bg-greylite cpy-15">
                          <div className="form-check mb-0">
                            <input
                              className="form-check-input me-1"
                              type="checkbox"
                              id="firstCheckboxStretched"
                              checked={isBuyingSheet}
                              onChange={(e) => {
                                setIsBuyingSheet(!isBuyingSheet);
                                isAllSheetSelected(isPurchaseOrder, !isBuyingSheet, isWarehouseSheet)
                              }}
                            />
                            <label
                              className="form-check-label cms-6"
                              htmlFor="firstCheckboxStretched"
                            >
                              Buying Sheet
                            </label>
                          </div>
                          {isBuyingSheet && <ul className="list-group">
                            <li className="list-group-item bg-greylite border-0">
                              <div>
                                <input
                                  className="form-check-input me-1"
                                  type="radio"
                                  id="radioPrice"
                                  name="buyingPrices"
                                  checked={isBuyingPrice}
                                  onChange={(e) => {
                                    setIsBuyingPrice(true)
                                  }}
                                />
                                <label
                                  className="form-check-label cms-6"
                                  htmlFor="radioPrice"
                                >
                                  Price
                                </label>
                              </div>

                              <div>
                                <input
                                  className="form-check-input me-1"
                                  type="radio"
                                  id="radioWithoutPrice"
                                  name="buyingPrices"
                                  checked={!isBuyingPrice}
                                  onChange={(e) => {
                                    setIsBuyingPrice(false)
                                  }}
                                />
                                <label
                                  className="form-check-label cms-6"
                                  htmlFor="radioPrice"
                                >
                                  Without Price
                                </label>
                              </div>
                            </li>
                          </ul>
                          }
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center bg-greylite cpy-11">
                          <div className="form-check mb-0 d-flex align-items-center">
                            <input
                              className="form-check-input me-1"
                              type="checkbox"
                              id="firstCheckboxStretched2"
                              checked={isWarehouseSheet}
                              onChange={(e) => {
                                setIsWarehouseSheet(!isWarehouseSheet)
                                isAllSheetSelected(isPurchaseOrder, isBuyingSheet, !isWarehouseSheet)
                              }}
                            />

                            <label
                              className="form-check-label cms-6"
                              htmlFor="firstCheckboxStretched2"
                            >

                              Warehouse forms
                            </label>
                          </div>

                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="spacer-3"></div>
                  <div>
                    <h2 className="title-medium  fs-16 mb-3">Criteria</h2>
                    <form>
                      <div className="cmb-14 row gx-3 gy-2 custom-group">
                        <label className="col-xl-2 d-flex align-items-center fs-14 text-lite text-nowrap justify-content-xl-end">
                          From Date:
                        </label>
                        <div className="col-4">
                          <div
                            className="position-relative"
                            data-provide="datepicker"
                            style={{ minWidth: "174px" }}
                          >
                            <input
                              type="date"
                              // id="datepicker"
                              className="form-control date input-sm input-datepicker"
                              placeholder="Select Date"
                              style={{ minWidth: "174px" }}
                              value={fromDate}
                              onChange={(e) => {
                                setFromDate(e.target.value);
                                setAgents([]);
                                setAgentId("All Agents")
                                setCustomers([]);
                                setCustomerId("all")
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      {(isBuyingSheet || isPurchaseOrder) && isWarehouseSheet === false ? (<div className="cmb-14 row gx-3 gy-2 custom-group">
                        <label className="col-xl-2 d-flex align-items-center fs-14 text-lite text-nowrap justify-content-xl-end">
                          Agent:
                        </label>
                        <div className="col">
                          <select
                            className="form-select input-sm "
                            aria-label="Default select example"
                            onChange={(e) => {
                              const [id, code] = e.target.value.split("||")
                              setAgentId(id)
                              setAgentCode(code)
                              setUserName(code);
                            }}
                            value={`${agentId}||${agentCode}`}
                          >
                            <option >All Agents</option>
                            {agents.map((agent, agentIndex) => {
                              return (<option key={agentIndex} value={`${agent.AgentID}||${agent.AgentCode}`}>{agent.AgentCode}</option>)
                            })}
                          </select>
                        </div>
                      </div>) : ""}
                      {isWarehouseSheet && (isBuyingSheet || isPurchaseOrder) === false ? (<div className="cmb-14 row gx-3 gy-2 custom-group">
                        <label className="col-xl-2 d-flex align-items-center fs-14 text-lite text-nowrap justify-content-xl-end">
                          Customer:
                        </label>
                        <div className="col">
                          <select
                            className="form-select input-sm "
                            aria-label="Default select example"
                            onChange={(e) => {
                              setCustomerId(e.target.value)
                            }}
                            value={`${customerId}`}
                          >
                            <option value={"all"}>All Customers</option>
                            {customers.map((customer, customerIndex) => {
                              return (<option key={customerIndex} value={customer.value}>{customer.CustomerCode}</option>)
                            })}
                          </select>
                        </div>
                      </div>) : ""}
                    </form>
                  </div>
                </div>
                <div className="card-footer bg-white d-flex p-3">
                  <a
                    href="#"
                    className="btn btn-outline-lite btn-md text-dark d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                  >
                    <i className="icon icon-chat me-2"></i> Enter notes
                  </a>
                  <button
                    className={`btn btn-outline-secondary btn-md ms-auto d-flex align-items-center px-4 fw-medium rounded-3 mx-1 ${(agentId || customerId) && ((buyingSheetData.length > 0) || (warehouseSheetData.length > 0)) ? "" : "disabled"}`}
                    onClick={() => handlePrintSheets(true)}
                  >
                    Preview
                  </button>
                  <button className={`btn btn-outline-secondary btn-md d-flex align-items-center px-4 fw-medium rounded-3 mx-1 ${(agentId || customerId) && ((buyingSheetData.length > 0) || (warehouseSheetData.length > 0)) ? "" : "disabled"}`} disabled={handleEmailDisabled()} onClick={() => setShowEmailModal(true)}>Email</button>
                  <button
                    className={`btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3 mx-1 ${(agentId || customerId) && ((buyingSheetData.length > 0) || (warehouseSheetData.length > 0)) ? "" : "disabled"}`}
                    onClick={() => handlePrintSheets(false)}
                  >
                    Print
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}
export default PrintOrders;
